export default "__VITE_ASSET__86SR2uvx__"